import createAPIRequestId from '../helpers/createAPIRequestId'
import store from '../store/index'
//---------------------
// edit character rune
//---------------------
export default async function useEditCharacterRune(rune, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterRune....')
  console.log('rune:', rune)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false

  if (rune.id !== undefined && rune.id !== null && rune.id !== '') {
    parm_id = rune.id
    parm_partialInd = rune.action !== 'DELETE' ? true : false
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  let endpoint = 'api/v1/character-runes/'
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (rune.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where not DELETE
  //----------------------------------
  if (rune.action !== 'DELETE') {
    api_parms.payload = rune.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterRune', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterRune preview result:', res)
      return res
    })
    .catch((err) => {
      if (err?.response?.status === 404 && rune.action === 'DELETE') {
        console.warn(
          'CharacterRune already deleted; treating DELETE as successful for rune =',
          rune.name,
        )

        return {
          data: null,
          status: 204,
          statusText: 'No Content',
        }
      }

      if (err?.response?.status === 404 && rune.action === 'UPDATE' && rune.full_payload) {
        console.warn('CharacterRune id no longer exists; retrying as ADD for rune =', rune.name)

        const retryPayload = {
          ...rune.full_payload,
          ...(rune.payload || {}),
        }

        const retryRequest = createAPIRequestId({
          endpoint: preview ? endpoint + '?preview=true' : endpoint,
          partialInd: false,
          id: null,
        })

        return this_store.dispatch('characters/editCharacterRune', {
          api_request: retryRequest,
          api_preview: preview,
          payload: retryPayload,
        })
      }

      console.error('editCharacterRune error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
